module.exports = __webpack_public_path__ + "img/live-rtmp-tutorial-1.7f111fbe.png";